import React from 'react'
import { Box, Typography } from '@mui/material'
import CallIcon from '@mui/icons-material/Call';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';
const NoteHistory = ({ details }) => {

const getIcons = (note) => {
  const text = note?.toLowerCase() || "";

  const iconMap = [
    { keyword: "call", icon: CallIcon, bg: "#14AE5C" },
    { keyword: "email", icon: MailOutlinedIcon, bg: "#F24822" },
  ];

  const matched = iconMap.find(({ keyword }) => text.includes(keyword));
  const Icon = matched?.icon || FileOpenOutlinedIcon;
  const background = matched?.bg || "#14AE5C";

  return (
    <Icon
      sx={{
        background,
        color: "#fff",
        width: 30,
        height: 30,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "50%",
        fontSize: 14,
        p: "5px",
      }}
    />
  );
};

    return (
        <>
            <Box sx={{  background: '#fff', boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px;', padding: '25px', borderRadius: '16px', marginBottom: '25px', height: details?.noteHistory?.length ? '400px' :'auto' , overflowY: 'scroll'}}>
                <Box>
                    <Typography variant='h2' sx={{ color: '#1E1E1E', fontSize: { xl: '24px !important', lg: '17px !important' }, marginBottom: '20px', fontWeight: '500' }}>Note History</Typography>
                </Box>
                { details?.noteHistory?.length ? details?.noteHistory?.map(item => {
                    return <Box key={item?._id} sx={{ display: 'flex', gap: '10px', borderBottom: '1px solid #D2D2D2', paddingBottom: '15px', marginBottom: '20px' }}>
                        <Box>
                            {getIcons(item?.note)}
                        </Box>
                        <Box>
                            <Typography sx={{ fontWeight: '400', color: '#1E1E1E', fontSize: { xl: '16px !important', lg: '13px !important' } }}>{item?.note}</Typography>
                            <Box sx={{ display: 'flex', marginTop: '10px', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                                <Typography sx={{ fontSize: { xl: '16px !important', lg: '13px !important' }, color: '#787878', fontWeight: '400' }}>
                                    Added by {item?.fullName}
                                </Typography>
                                <Typography sx={{ fontSize: { xl: '14px !important', lg: '12px !important' }, color: '#787878', fontWeight: '400' }}>
                                    {item?.date} · {item?.time}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                }) : <Box sx={{ textAlign: 'center', marginBottom: '16px' }}>
                    <Typography sx={{ color: '#1E1E1E', fontSize: { xl: '18px !important', lg: '14px !important' }, fontWeight: 500 }}>
                        No notes
                    </Typography>
                </Box>}
            </Box>
        </>
    )
}

export default NoteHistory